import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import '../../../assets/styles/instructor.css'
import image1 from '../../../assets/images/banner-img-3.jpg'
import image3 from '../../../assets/images/banner-img-1.jpg'
import image2 from '../../../assets/images/banner-img-2.jpg'
import ContactCta from '../../Reusable/ContactCta'
import { config } from '../config'

const BecomeInstructor = () => {


    const workSteps = [
        {
            title: "Sign Up ",
            desc: "Create your instructor profile and provide your details. "
        },
        {
            title: "️Give Your Availability",
            desc: "Set your schedule so learners know when you're available. "
        },
        {
            title: "Start Teaching ",
            desc: "Get booked, conduct lessons, and grow your reputation! "
        }
    ]

    return (
        <>
            <Bredcrum
                heading={'How to become Instructor'}
                path={[
                    { name: 'How to become Instructor', path: 'how-to-become-instructor' },
                ]}
            />

            <div className=' my-5'>

                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div >
                        <div className="sec-title ">
                            <h3 className='mb-4 fs-2 fw-semibold'>Share Your Expertise & Help Others Gain Confidence on the Road </h3>
                            <p className='d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Are you a qualified driving instructor looking to expand your student base and grow your business? Join Precision Driving and take control of your schedule, earnings, and teaching style. Our platform connects you with eager learners, making it easier than ever to manage bookings and provide top-quality lessons—without the hassle of marketing or administration. 
                            </p>
                        </div>
                        <div className="sec-title ">
                            <h5 class="fw-bold mb-3">Why Join Precision Driving? </h5>

                            <PointComp
                                title={"Instant Access to Students"}
                                content={"No waiting period—sign up, set your availability, and start getting bookings right away."} />
                            <PointComp
                                title={"Flexible Scheduling"}
                                content={" Work on your terms by giving your availability and managing your own schedule. Teach as much or as little as you like. "} />
                            <PointComp
                                title={" Increase Your Earnings"}
                                content={"Reach more learners without spending on advertising. Our platform helps you maximize your income with a steady stream of students."} />
                            <PointComp
                                title={"Simple & Efficient Lesson Management "}
                                content={" Easily track bookings, reschedule lessons, and communicate with students—all in one place. "} />
                            <PointComp
                                title={"No Complicated Onboarding "}
                                content={" No lengthy approvals or restrictions—just sign up and start teaching. "} />

                        </div>

                        <div>
                            <h5 class="fw-bold mb-4">How It Works  </h5>
                            <div className="row">
                                {
                                    workSteps.map((course, i) => {
                                        return (
                                            <CourseCard key={i} course={course} />
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className='mt-4'>
                            <h5 class="fw-bold mb-4">Who Can Join?  </h5>
                            <p className='d-flex '>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                <div>
                                    We welcome <b>DVSA-approved driving instructors</b> who are passionate about teaching and helping learners succeed. Whether you're an independent instructor or part of a driving school, Precision Driving gives you the tools to manage your lessons with ease.
                                </div>
                            </p>
                        </div>

                        <div className='my-5'>
                            <h5 class="fw-bold mb-4">Join Us Today!  </h5>
                            <p className='d-flex '>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Take the next step in your instructor career with Precision Driving. Sign up now, set your availability, and start connecting with students instantly!
                            </p>
                        </div>

                        <div>
                            <div>
                                <button className='button theme-btn btn-one text-white' onClick={() => window.open(`${config.appUrl}instructor/sign-up`)}>Get Started Now </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div >
                        <div className="sec-title ">
                            <h3 className='mb-4 fs-2 fw-semibold'>DVSA Requirements to become a driving instructor</h3>
                            <p className='d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                The Driver and Vehicle Standards Agency (DVSA) is an executive agency of the Department of Transport. In respect to driver training the agency is responsible for conducting all theory and practical driving tests in Great Britain and has the responsibility for maintaining the Register of Approved Driving Instructors (ADIs) and the Official Register of Driving Instructor Trainers (ORDIT).
                            </p>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                It is illegal for anyone to charge for driving tuition unless their name is on the Register of ADIs or they are licenced as part of the Trainee Licence scheme. To become an ADI you need to pass the DVSA ADI qualifying examination and meet certain minimum legal requirements. You must:
                            </p>
                            {/* <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                You are required to complete a Disclosure and Barring Service (DBS) check through the Government's Online Disclosure Service to ensure a thorough assessment of your background.
                            </p> */}

                            <ol start={1} className='mt-4 ' style={{ listStyle: 'initial' }}>
                                <li className='d-flex mb-2'><b className='me-1'>1. </b>Hold a full UK or EEA unrestricted car driving licence;</li>
                                <li className='d-flex mb-2'><b className='me-1'>2. </b>Be aged 21. You can start the qualifying process 6 months before your 21st birthday. You must have had your full licence for at least 3 years to supervise a learner driver.</li>
                                <li className='d-flex mb-2'><b className='me-1'>3. </b>Have held your licence for at least 2.5 years prior to entering the Register after qualifying;</li>
                                <li className='d-flex mb-2'><b className='me-1'>4. </b>Not have been disqualified from driving at any time in the 4 years prior to being entered in the Register;</li>
                                <li className='d-flex mb-2'><b className='me-1'>5. </b>Be a ‘fit and proper’ person to have your name entered in the Register. All convictions, motoring or non-motoring still in force will be taken into account by the DVSA before allowing you on the Register and from experience we know that anyone with 6 or more points on their licence within the last 4 years prior to entry on the Register is likely to be rejected. You will need to apply for a DBS check as part of this process.</li>
                            </ol>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Remember the DVSA are the sole decision maker on who can and who can't train to become a driving instructor.
                            </p>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                You should also ensure you can read a number plate in good daylight at a distance of 27.5 metres or 26.5 metres depending on the width of the lettering (with glasses if normally worn for driving) as this will be checked on Part 2 of the qualifying examination. On the normal driving test you need only read a number plate at 20.5 metres or 20 metres depending on the width of the lettering.
                            </p>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Please also note that on the Part 2 driving test you must be able to take rear observations by looking round when reversing without heavy dependency on the mirrors. So if you have minimal neck movement this will need to be checked before you start, since you are not allowed additional mirrors as on the ordinary driving test.
                            </p>


                        </div>

                        <div className="sec-title">
                            <h3 className='mb-4 fs-2 fw-semibold'>The ADI qualifying examination</h3>
                            <p>The DVSA ADI qualifying examination is in three parts:</p>

                            <div className='my-4'>
                                <p className='mb-2'><b>Part 1 : </b> Theory - consists of a multiple-choice test and a video based hazard perception test.</p>
                                <p className='mb-2'><b>Part 2 : </b> Driving - consists of an eyesight test, show me tell me safety check questions, followed by a practical driving test.</p>
                                <p className='mb-2'><b>Part 3 : </b>Instructional ability - consists of a practical test of the ability to instruct.</p>
                            </div>

                            <p className='d-flex '>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Once you have passed Part 1 you are required to undertake and pass the two remaining parts within two years. You are permitted an unlimited number of attempts at Part 1, however for Part 2 and Part 3 you are only allowed three attempts at each test. Should you fail a third attempt at Part 2 or Part 3 you would have to restart qualification again after 2 years had elapsed from your Part 1 pass date.
                            </p>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Waiting time for Part 1 is minimal; however because you need to obtain a DBS and seek DVSA approval first, the Part 1 test cannot be taken for about 4 to 6 weeks. Waiting time for a Part 2 or Part 3 test appointment is also about 6 to 12 weeks, consequently the exam process itself from start to finish is about 18 to 24 weeks assuming there are no other delays. This is why intensive driving instructor training may not be suitable depending on the exam waiting times in your area.
                            </p>
                        </div>

                        <div>
                            <button className='button theme-btn btn-one text-white' onClick={() => window.open(`${config.appUrl}instructor/sign-up`)}>Become an Instructor </button>
                        </div>
                    </div>
                </div>
            </div>

            <section className='py-5'>
                <div className="auto-container pb-md-5">
                    <ul className="nav nav-tabs " id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                                PART <i className="bi bi-1-circle-fill fs-5 ms-1"></i>  </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                PART <i className="bi bi-2-circle-fill fs-5 ms-1"></i> </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">
                                PART <i className="bi bi-3-circle-fill fs-5 ms-2"></i></button>
                        </li>
                    </ul>

                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                            <div className="row mt-5">
                                <div className="col-md-8">
                                    <h2 className='fw-bold mb-4 text-dark'>Part 1 Theory</h2>
                                    {/* 

                                    <p >
                                        In the Part 1 course you pay for the training course and study aids for it. You can work at your own pace, with Fast Track Training available.
                                    </p>
                                    <p className='mt-3'>
                                        You will also get support from your Tutor via telephone, online or personally.
                                    </p>
                                    <p className='mt-3'>
                                        Your test for part 1 involves 100 multiple choice questions as well as a hazard perception test.
                                    </p> */}

                                    <div>
                                        <h5 className='fw-bold mb-3'>Multiple-choice questions</h5>

                                        <p className='fw-semibold'>
                                            This section tests your knowledge of the Highway Code and other instructional matters via a Personal Computer and lasts for 90 minutes. You are asked 100 questions with optional voice-over. For each question four answers are shown on the screen and you are required to select the answer you think is correct. To pass you are required to answer 85 questions correctly overall (including 20 within each of the 4 subject groups tested, also known as bands). Below is a list of the topics covered and which band or group (i.e. 1 to 4) they belong too:
                                        </p>

                                        <p className='mt-3'>
                                            There are 25 questions in each of these 4 categories:
                                        </p>

                                        <div className='my-4'>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                1. Road procedure (25 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                2a. Trafic signs and signals (5 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                2b. Car Control (10 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                2c. Pedestrians (5 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                2d. Mechanical knowledge (5 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                3a. Driving test (10 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                3b. Disabilities (5 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                3c. The law (10 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                4a. Recommended publications (10 questions)
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                4b. Instruction knowledge (15 questions)
                                            </p>







                                        </div>

                                        <p >
                                            If you have any type of reading difficulties you can ask for a voice over or request additional time within which to complete the test. If you would like to see how this test works in practice you can access our <a href="https://www.adi-theory.co.uk/" className='text-green'>FREE Theory Test</a>  webpage.
                                        </p>

                                    </div>

                                    <div className='mt-md-0 mt-5'>

                                        <h5 className='fw-bold my-4'>Hazard Perception</h5>

                                        <p className='mt-3'>
                                            This section tests your ability to identify moving hazards ahead, that are likely to cause you to slow down, stop or change direction. The test requires you to watch 14 video clips, each filmed from the drivers eye view of a car as it drives down the road. Each time you see a moving hazard start to develop you would click the computer mouse button to let the program know you have seen the problem. The earlier you see the warning signs and click the mouse button, the higher your score will be. A maximum of 5 can be scored on any hazard and a total of 15 hazards are shown with at least 1 per clip and with one clip having 2. To pass this test you have to score 57 out of a maximum possible score of 75 (i.e. 15x5).
                                        </p>

                                        {/* <div className='mt-4'>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                Feature everyday road scenes
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                Contain at least one ‘developing hazard’ - but one of the clips features 2 developing hazards - You get points for spotting the developing hazards as soon as they start to happen.
                                            </p>
                                        </div> */}

                                        <p className='mt-3'>
                                            If you would like to experience how this test works you can access the <a href="https://www.adi-theory.co.uk/" className='text-green'>FREE Hazard Perception Test</a>  webpage but remember unlike a learner driver who only needs 44 to pass you will require 57.
                                        </p>

                                    </div>
                                </div>

                                <div className="col-md-4 mt-md-0 mt-5">
                                    <img src={image1} alt="" />
                                </div>
                            </div>

                        </div>

                        <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                            <div className="row mt-5">
                                <div className="col-md-4 ">
                                    <img src={image2} alt="" />
                                </div>
                                <div className="col-md-8 ps-md-5 mt-md-0 mt-5">
                                    <h2 className='fw-bold mb-4 text-dark'>Part 2 Driving</h2>
                                    <p>
                                        The Part 2 driving test closely resembles the current test for learners in format and content. However, the eyesight test requires you to see a number plate at a slightly longer distance (i.e. 27.5 metres or 26.5 metres depending on the width of the lettering), the duration of the test is longer to allow you to undertake all the set manoeuvres and you are expected to perform to a higher standard. Unlike the L test you are only permitted a maximum of 6 minor driving faults and what constitutes a minor driving fault may be more harshly assessed.
                                    </p>

                                    {/* <p className='mt-3'>
                                        Your driving will be assessed and your course planned by your tutor; usually in 2 hour sessions leading up to your Part 2 Driving test.
                                    </p> */}

                                    {/* <div>

                                        <h5 className='fw-bold my-4'>Your Test</h5>

                                        <p className='fw-semibold'>
                                            It’s the second of 3 tests you have to pass to qualify as an ADI. It’s a test of your driving ability.
                                        </p>

                                        <p className='mt-3'>
                                            You'll begin with a test of your eyesight, followed by show me/ tell me questions and a 1-hour practical test. During this, you'll need to perform manoeuvres and demonstrate a high technical driving standard.
                                        </p>

                                        <p className='mt-3'>
                                            To pass the test you must be able to:
                                        </p>

                                        <div className='mt-4'>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                Drive safely in different road and traffic conditions
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                Show that you know The Highway Code by the way you drive
                                            </p>
                                        </div>

                                        <p className='mt-3'>
                                            You only get 3 attempts at the Part 2 test.
                                        </p>
                                    </div> */}
                                </div>
                            </div>

                        </div>

                        <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

                            <div className="row mt-5">
                                <div className="col-md-8">
                                    <h2 className='fw-bold mb-4 text-dark'>Part 3 Instructional ability</h2>
                                    <p>
                                        In 2018 the DVSA introduced a new Part 3 test. In the new ADI Part 3 test the examiner wants to observe you delivering a real driving lesson to one of your pupils, rather than the examiner pretending to be a pupil as was the case prior to 2018. In many ways this makes the test easier as a real pupil isn’t trying to catch you out but the downside is you will need to show you can perform all aspects of the job for real rather than just pick up and correct driving faults that the examiner makes as was the case before 2018.
                                    </p>

                                    <p className='mt-3'>
                                        The examiner now needs to observe you from the back seat of your car delivering a driving lesson for real. Consequently, any course must now incorporate a large amount of real on-the-job practical training to ensure you succeed. Look out fr training providers who are now selling online training only.
                                    </p>
                                    <p className='mt-3'>
                                        The examiner is now assessing you on your ability to tailor the training to your pupil’s learning goals and needs. In particular, the examiner will:
                                    </p>

                                    <div>
                                        <div className='mt-4'>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                Look for evidence that the trainee instructor meets the national standard for driver and rider training
                                            </p>
                                            <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                                <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green"
                                                    style={{ backgroundColor: "#f2f2f2" }}></i>
                                                Mark 17 areas of competence in 3 categories – lesson planning, risk management and teaching and learning skills
                                            </p>
                                        </div>

                                    </div>

                                    <div>
                                        <h5 className='fw-bold mt-5 mb-4'>Trainee licence</h5>

                                        <p >
                                            After you have passed Part 2 of the ADI examination (and undertaken the necessary training to be able to do the job) you can potentially start to earn money as a trainee driving instructor. In this way you can start to earn money earlier then you might otherwise and you also get the opportunity to gain some real on-the-job experience to help you pass the third and final part of the ADI examination.
                                        </p>
                                        <p className="mt-3">
                                            To obtain a trainee licence you have to be sponsored by, and work with, an established driving school such as LDC. Please note not every driving school supports the trainee licence scheme.
                                        </p>

                                        <div>
                                            <h6 className='mt-4'>Conditions of a trainee licence</h6>

                                            <ol start={1} className='mt-4 ' style={{ listStyle: 'initial' }}>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>1. </b>You are only authorised to give instruction for the school whose address is shown on the licence (i.e. the sponsoring driving school)
                                                </li>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>2. </b>You must not advertise yourself as a fully qualified instructor.
                                                </li>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>3. </b>
                                                    You must receive 40 hours practical Part 3 training from a qualified ADI before you apply for your licence, of which at least 25 per cent must be in-car training either 2-to-1 or 1-to-1. All this training must have occurred within 6 months of starting the licence. It is your responsibility to make sure that you receive training in each of the specified subjects. You must submit a completed Instructor Training Declaration (ADI 21T) with your application and have it signed on behalf of the sponsoring driving school and the trainer or trainers if more than one was used.
                                                </li>
                                            </ol>
                                        </div>

                                        <div>
                                            <h6 className='mt-4'>Condition 1</h6>

                                            <ol start={1} className='mt-4 ' style={{ listStyle: 'initial' }}>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>1. </b>You must receive supervision for 20 per cent of all lessons you give from your sponsoring ADI
                                                </li>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>2. </b>A record of all lessons given, along with the supervision received must be kept on the form ADI 21S which will be issued with the licence. This must be signed by you and your ADI and must be returned to the Driver and Vehicle Standards Agency (DVSA) as soon as the licence expires; or
                                                </li>
                                            </ol>
                                        </div>

                                        <div>
                                            <h6 className='mt-4'>Condition 2</h6>

                                            <ol start={1} className='mt-4 ' style={{ listStyle: 'initial' }}>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>1. </b>You must receive a minimum additional 20 hours of Part 3 training covering all the specified topics
                                                </li>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>2. </b>This extra training must take place within the first three months of the licence or before you take your first attempt at part 3, whichever is the soonest
                                                </li>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>3. </b>
                                                    A record of this training must be kept on the form ADI 21AT, and must be sent to DVSA before the end of the three month period, or presented to the examiner conducting the part 3 test, whichever is the earliest
                                                </li>
                                                <li className='d-flex mb-2'>
                                                    <b className='me-1'>2. </b>At least 25 per cent of the training will have to be practical in-car training either 2-1 or 1-1 and again the trainer or trainers must sign the form to confirm the required training has taken place.
                                                </li>
                                            </ol>
                                        </div>

                                        <div>
                                            <h6 className='mt-4'>Displaying the trainee licence</h6>
                                            <p className='mt-3'>
                                                When instruction is being given the licence must be displayed in the bottom left hand corner of the front windscreen. The use of the licence is your own responsibility. No refunds will be given for any period when the licence is not used.
                                            </p>
                                            <p className='mt-3'>
                                                If you cannot make full use of your licence and you have to stop giving tuition, return it to the issuing office immediately. If your trainee licence is lost or stolen you should report it to the Police and to the DVSA straight away.
                                            </p>
                                        </div>


                                    </div>
                                    <div>
                                        <h5 className='fw-bold my-4'>Emergency Control Certificates for Disabled Instructors</h5>
                                        <p className='mt-3'>
                                            The Road Traffic (Driving Instruction by Disabled Persons) Act 1993 came into effect on 9 September, 1996 making provision to enable persons with a physical disability to be authorised to become driving instructors. It is only open to drivers whose driving licence is restricted to automatics because of a disability. In order to apply to become an Instructor, applicants must first obtain a certificate which verifies their ability to take control of the tuition vehicle when necessary.
                                        </p>
                                        <p className='mt-3 fw-semibold'>The Training and Development Centre at Cardington are responsible for the assessments leading to the issue of the Emergency Control Certificates (ECC) previously carried out by The Mobility Advice and Vehicle (MAVIS).</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-md-0 mt-5">
                                    <img src={image3} alt="" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <ContactCta />
        </>
    )
}


function PointComp({ title, content }) {
    return (
        <div className='d-flex mt-4'>
            <i className='bi bi-chevron-double-right me-3 text-green'></i>
            <div>
                <h6 className='mb-2'>
                    {title}
                </h6>
                <p>{content}</p>
            </div>
        </div>
    )
}

const CourseCard = ({ course }) => {
    return <div className="col-md-4 mb-4">
        <div className='b-white card rounded-0 border-0 shadow-sm p-4' style={{ minHeight: "150px" }}>
            <h5 className='text-green fw-bold'> {course.title} </h5>
            <p className='mt-3'>
                {course.desc}
            </p>
        </div>
    </div>
}

export default BecomeInstructor